import { render, staticRenderFns } from "./GroupDetails.vue?vue&type=template&id=6f741991&scoped=true"
import script from "./GroupDetails.vue?vue&type=script&lang=js"
export * from "./GroupDetails.vue?vue&type=script&lang=js"
import style0 from "./GroupDetails.vue?vue&type=style&index=0&id=6f741991&prod&scoped=true&lang=css"
import style1 from "./GroupDetails.vue?vue&type=style&index=1&id=6f741991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f741991",
  null
  
)

export default component.exports